import { Yup, type YupTypes } from "../../../form"
import { fields } from "./pinDialog.const"

export const pinDialogSchema = Yup.object({
  [fields.password]: Yup.string().length(4).required(),
})

export type PinFormValue = YupTypes.InferType<typeof pinDialogSchema>
